// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"b6e4820b","167":"2c91468d","423":"4c5c1c05","437":"d1156d02","615":"55e06b14","680":"c51e6888","817":"ae156232","836":"62672491","954":"c8bd824c"}[chunkId] + ".chunk.js";
};